import React from "react";

function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 150 110">
      <g data-name="Layer 2">
        <path fill="none" d="M0 0h150v110H0z" data-name="Rectangle 15168" />
        <g data-name="Group 1418">
          <g data-name="Group 1412">
            <g
              fill="none"
              stroke="#424242"
              strokeLinecap="round"
              strokeWidth="3"
              data-name="Group 1387"
            >
              <circle
                cx="48.45"
                cy="63.19"
                r="6.8"
                strokeLinejoin="round"
                data-name="Ellipse 14"
              />
              <circle
                cx="99.55"
                cy="63.19"
                r="6.8"
                strokeLinejoin="round"
                data-name="Ellipse 15"
              />
              <path strokeLinejoin="round" d="M55.16 64.32H92.5" data-name="Line 90" />
              <path
                strokeLinejoin="round"
                d="M41.65 64.32h-5.4v-6.48a6.56 6.56 0 013.28-5.69 29 29 0 0114.41-3.67h41.67L99.54 44"
                data-name="Path 1182"
              />
              <path
                strokeLinejoin="round"
                d="M106.16 64.77l4.38-1.27a4.45 4.45 0 003.21-4.27V48l-7.59-.75s-25.28-17-51 1.28"
                data-name="Path 1183"
              />
              <path strokeLinejoin="round" d="M113.75 52.39h-3.67" data-name="Line 91" />
              <path d="M79.3 40v24.32" data-name="Path 1184" />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default Icon;
